import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './routing/routes';
import './App.css';
import { Toaster } from "sonner";
import { AppConfigProvider } from '@/shared/context/AppConfigProvider';
import { NetworkProvider } from '@/shared/context/NetworkContext';
import { AuthProvider } from '@/features/auth/providers/AuthProvider';
import { SessionTimeoutProvider } from '@/features/auth/providers/SessionTimeoutProvider';
import { RecaptchaProvider } from '@/shared/recaptcha';
import { environment } from '@/config/environment';
import { ReferenceDataLanguageInvalidator } from '@/shared/components/ReferenceDataLanguageInvalidator';
import { usePostHogSuperProperties } from '@/shared/posthog/usePostHogSuperProperties';
import { DocumentDirectionSync } from '@/shared/hooks/useDocumentDirection';

function PostHogSuperPropertiesSync() {
  usePostHogSuperProperties();
  return null;
}

function App() {
  return (
    <>
      <ReferenceDataLanguageInvalidator />
      <DocumentDirectionSync />
      <AppConfigProvider>
        <NetworkProvider>
          <RecaptchaProvider siteKey={environment.RECAPTCHA_SITE_KEY}>
            <Router>
              <AuthProvider>
                <PostHogSuperPropertiesSync />
                <SessionTimeoutProvider>
                  <AppRouter />
                </SessionTimeoutProvider>
              </AuthProvider>
            </Router>
            <Toaster
              className="pointer-events-auto"
              richColors
              closeButton
              position="top-right"
              toastOptions={{
                duration:12000,
                closeButton: true,
              }}
            />
          </RecaptchaProvider>
        </NetworkProvider>
      </AppConfigProvider>
    </>
  );
}

export default App;
